import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-798d68a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container mx-auto cap-sua-chua-form-wrapper" }
const _hoisted_2 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_3 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_4 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_5 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_6 = { class: "flex justify-center mt-3 gap-x-1" }
const _hoisted_7 = { class: "mt-8" }

import { useCreatingForm } from '@/core/hooks/use-creating-form';
	import {
		setBreadcrumbLinks,
		setCurrentPageTitle,
	} from '@/core/helpers/breadcrumb';
	import PageContentBase from '@/layout/_shared/PageContentBase.vue';
	import { ButtonsType, ButtonTypeColors } from '@/core/enums/buttons.enums';
	import ButtonCustom from '@/components/shared/buttons/ButtonCustom.vue';
	import DivRow from '@/layout/_shared/DivRow.vue';
	import DivCol from '@/layout/_shared/DivCol.vue';
	import LabelCustom from '@/components/shared/label-custom/LabelCustom.vue';
	import { nextTick, ref, onMounted, watch } from 'vue';
	import type { ElInput } from 'element-plus';
	import useTaiKhoan from '@/core/hooks/useTaiKhoan';
	import TaiKhoanSelectionV2 from '@/components/shared/tai-khoan-selection/TaiKhoanSelectionV2.vue';
	import { useLoading } from '@/core/hooks/use-loading';
	import {
		lengthValidationRules,
		swalErrNotification,
		swalNotification,
	} from '@/core/helpers/utils';
	import { generateAcronym } from '@/core/helpers/generateAcronym';
	import { CapSuaChuaService } from '@/core/services/CapSuaChuaService.service';
	import { useRoute, useRouter } from 'vue-router';
	import useFormInput from '@/core/hooks/use-form-input';
	import type { ICapSuaChuaResponseBase } from '@/core/interfaces/ApiResponses';
	import { resolveListPageForRoute } from '@/core/helpers/list-page-context';
	import { usePagination } from '@/core/hooks/use-pagination';
	import CapSuaChuaTable from '@/components/shared/cap-sua-chua-table/CapSuaChuaTable.vue';
	import Pagination from '@/components/shared/pagination/Pagination.vue';

	
export default /*#__PURE__*/_defineComponent({
  __name: 'Form',
  setup(__props) {

	const route = useRoute();
	const { id: idCapSuaChua, formRef, isCreating } = useCreatingForm();

	const { onSelectTaiKhoan, clearTaiKhoanData, tkData } = useTaiKhoan();

	const { startLoading, endLoading } = useLoading();

	const { currentPage, perPage, totalItems } = usePagination();
	currentPage.value = resolveListPageForRoute(route.query, {
		isCreate: isCreating.value,
	});

	const form = ref({
		ten_cap_sc: '',
		ten_viet_tat: '',
		mo_ta: '',
	});

	const capSuaChuaItems = ref<ICapSuaChuaResponseBase[]>([]);
	const isTenVietTatManuallyEdited = ref(false);
	const isTenVietTatAutoGenerated = ref(false);

	const rules = ref({
		ten_cap_sc: [
			...lengthValidationRules({
				name: 'Tên cấp sửa chữa',
				max: 80,
			}),
		],
		ten_viet_tat: [
			...lengthValidationRules({
				min: 1,
				max: 30,
				name: 'Tên viết tắt',
			}),
		],
		mo_ta: [
			...lengthValidationRules({
				isRequired: false,
				max: 150,
				name: 'Mô tả (ghi chú)',
			}),
		],
	});

	const { replace } = useRouter();

	const { focusFirstErrInput, focusFirstErrInputV2 } = useFormInput();

	const tenCapScInputRef = ref<InstanceType<typeof ElInput>>();

	const focusTenCapScInput = async () => {
		await nextTick();
		tenCapScInputRef.value?.focus();
		tenCapScInputRef.value?.select?.();
	};

	watch(
		() => form.value.ten_cap_sc,
		(newName) => {
			if (isTenVietTatManuallyEdited.value) {
				return;
			}

			form.value.ten_viet_tat = generateAcronym(newName);

			if (!isCreating.value) {
				isTenVietTatAutoGenerated.value = !!form.value.ten_viet_tat;
			}
		},
	);

	const onTenVietTatInput = () => {
		const generated = generateAcronym(form.value.ten_cap_sc);
		const isDifferentFromAuto = form.value.ten_viet_tat !== generated;

		isTenVietTatManuallyEdited.value = isDifferentFromAuto;

		if (isDifferentFromAuto) {
			isTenVietTatAutoGenerated.value = false;

			return;
		}

		if (!isCreating.value && generated) {
			isTenVietTatAutoGenerated.value = true;
		}
	};

	const clearForm = async () => {
		await nextTick();
		formRef.value?.resetFields();
	};

	const fetchDetailData = async () => {
		if (!idCapSuaChua.value) {
			return;
		}

		startLoading();

		try {
			const {
				data: {
					data: { mo_ta, ten_cap_sc, ten_viet_tat, tk_ketoan },
				},
			} = await CapSuaChuaService.get(idCapSuaChua.value);

			form.value.ten_cap_sc = ten_cap_sc;
			form.value.mo_ta = mo_ta;

			const savedTenVietTat = ten_viet_tat?.trim() ?? '';

			if (!savedTenVietTat) {
				form.value.ten_viet_tat = generateAcronym(ten_cap_sc);
				isTenVietTatAutoGenerated.value = !!form.value.ten_viet_tat;
				isTenVietTatManuallyEdited.value = false;
			} else {
				form.value.ten_viet_tat = savedTenVietTat;
				isTenVietTatAutoGenerated.value = false;
				isTenVietTatManuallyEdited.value = true;
			}
			tkData.value.maTaiKhoan = tk_ketoan?.matk ?? '';
			tkData.value.maChiTiet = tk_ketoan?.mact ?? '';
			tkData.value.tenTaiKhoan = tk_ketoan?.tentk ?? '';
			endLoading();
		} catch (e) {
			endLoading();

			swalErrNotification(e, 'Có lỗi xảy ra');
		}
	};

	const fetchCapSuaChuaList = async () => {
		startLoading();

		try {
			const {
				data: {
					data: { total, data },
				},
			} = await CapSuaChuaService.list({
				current_page: currentPage.value,
				per_page: perPage.value,
			});

			totalItems.value = total;
			capSuaChuaItems.value = data;

			endLoading();
		} catch (error) {
			endLoading();

			swalErrNotification(error, 'Có lỗi xảy ra');
		}
	};

	const onPageChange = (page: number) => {
		currentPage.value = page;
	};

	const onPageSizeChange = (size: number) => {
		perPage.value = size;
	};

	onMounted(async () => {
		await fetchDetailData();
		await fetchCapSuaChuaList();

		setBreadcrumbLinks([
			{
				text: 'Cấp sửa chữa',
				routeData: {
					name: 'danh-sach-cap-sua-chua',
				},
			},
			...(isCreating.value
				? []
				: [
						{
							text: 'Chi tiết',
							routeData: {
								name: 'chi-tiet-cap-sua-chua',
								params: {
									id: idCapSuaChua.value,
								},
							},
						},
					]),
			{
				text: isCreating.value ? 'Tạo mới' : 'Chỉnh sửa',
			},
		]);

		document.title = isCreating.value
			? 'Tạo mới - Cấp sửa chữa - Đường sắt Hà Nội'
			: `${form.value.ten_cap_sc} - Chỉnh sửa - Cấp sửa chữa - Đường sắt Hà Nội`;

		setCurrentPageTitle(
			isCreating.value ? 'Tạo mới cấp sửa chữa' : `(${form.value.ten_cap_sc})`,
		);

		await focusTenCapScInput();
	});

	/** Reload when table row actions navigate create ↔ edit or another edit id */
	watch(
		() => [idCapSuaChua.value, isCreating.value] as const,
		async ([nextId, creating], [prevId, prevCreating]) => {
			if (creating) {
				currentPage.value = resolveListPageForRoute(route.query, {
					isCreate: true,
				});

				if (!prevCreating) {
					await clearForm();
					clearTaiKhoanData();
					document.title = 'Tạo mới - Cấp sửa chữa - Đường sắt Hà Nội';
					setCurrentPageTitle('Tạo mới cấp sửa chữa');
					await focusTenCapScInput();
				}

				return;
			}

			if (!nextId || (nextId === prevId && !prevCreating)) {
				return;
			}

			currentPage.value = resolveListPageForRoute(route.query, {
				isCreate: false,
			});
			await fetchDetailData();
			document.title = `${form.value.ten_cap_sc} - Chỉnh sửa - Cấp sửa chữa - Đường sắt Hà Nội`;
			setCurrentPageTitle(`(${form.value.ten_cap_sc})`);
			await focusTenCapScInput();
		},
	);

	const onSubmit = async (isRedirect: boolean) => {
		if (!tkData.value.maTaiKhoan) {
			await focusFirstErrInput('tai-khoan-selection_tai-khoan');

			await swalNotification('Bắt buộc phải nhập thông tin tài khoản', 'error');

			return;
		}

		if (!formRef.value) {
			return;
		}

		formRef.value?.validate(async (valid) => {
			if (valid) {
				startLoading();

				try {
					await CapSuaChuaService.createOrUpdate({
						ten_cap_sc: form.value.ten_cap_sc,
						ten_viet_tat: form.value.ten_viet_tat,
						matk: tkData.value.maTaiKhoan,
						tentk: tkData.value.tenTaiKhoan,
						...(tkData.value.maChiTiet && {
							mact: tkData.value.maChiTiet,
						}),
						mo_ta: form.value.mo_ta,
						...(!isCreating.value && {
							id_cap_sc: idCapSuaChua.value,
						}),
					});

					endLoading();

					await swalNotification(
						`${isCreating.value ? 'Tạo mới' : 'Chỉnh sửa'} thành công`,
					);

					if (isRedirect) {
						replace({
							name: 'danh-sach-cap-sua-chua',
						});

						return;
					}

					if (currentPage.value !== 1) {
						currentPage.value = 1;

						return;
					}

					clearForm();
					await fetchCapSuaChuaList();
				} catch (e) {
					endLoading();

					swalErrNotification(e, 'Có lỗi xảy ra');
				}
			} else {
				await focusFirstErrInputV2();

				return false;
			}
		});
	};

	watch(
		() => currentPage.value,
		() => {
			fetchCapSuaChuaList();
		},
	);

	watch(
		() => perPage.value,
		() => {
			nextTick().then(() => {
				if (currentPage.value === 1) {
					fetchCapSuaChuaList();

					return;
				}

				currentPage.value = 1;
			});
		},
	);

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(PageContentBase, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_form, {
          ref_key: "formRef",
          ref: formRef,
          model: form.value,
          rules: rules.value,
          onSubmit: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (onSubmit(false)), ["prevent"]))
        }, {
          default: _withCtx(() => [
            _createVNode(DivRow, { class: "mb-3 g-3" }, {
              default: _withCtx(() => [
                _createVNode(DivCol, {
                  "additional-class": "pb-4",
                  cols: 3
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _createVNode(LabelCustom, { isRequired: "" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Tên cấp sửa chữa")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        prop: "ten_cap_sc",
                        class: "mb-0 w-full"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            ref_key: "tenCapScInputRef",
                            ref: tenCapScInputRef,
                            modelValue: form.value.ten_cap_sc,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.ten_cap_sc) = $event)),
                            placeholder: "Tên cấp sửa chữa",
                            name: "ten_cap_sc",
                            onFocus: _cache[1] || (_cache[1] = ($event: any) => ($event.target.select()))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(DivCol, {
                  "additional-class": "pb-4",
                  cols: 2
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(LabelCustom, { isRequired: "" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Tên viết tắt")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        prop: "ten_viet_tat",
                        class: "mb-0 w-full"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: form.value.ten_viet_tat,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.ten_viet_tat) = $event)),
                            class: _normalizeClass({
											'cap-sc-ten-viet-tat--auto': isTenVietTatAutoGenerated.value,
										}),
                            placeholder: "Tên viết tắt",
                            name: "ten_viet_tat",
                            onFocus: _cache[3] || (_cache[3] = ($event: any) => ($event.target.select())),
                            onInput: onTenVietTatInput
                          }, null, 8, ["modelValue", "class"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(DivCol, {
                  "additional-class": "pb-4",
                  cols: 7
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(LabelCustom, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Mô tả (ghi chú)")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        prop: "mo_ta",
                        class: "mb-0 w-full"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: form.value.mo_ta,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.mo_ta) = $event)),
                            placeholder: "Mô tả (ghi chú)",
                            name: "mo_ta",
                            type: "textarea",
                            autosize: { minRows: 1 },
                            resize: "none",
                            onFocus: _cache[5] || (_cache[5] = ($event: any) => ($event.target.select()))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(DivRow, { class: "mb-3" }, {
              default: _withCtx(() => [
                _createVNode(DivCol, {
                  "additional-class": "pb-4",
                  cols: 12
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(LabelCustom, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Tài khoản kế toán")
                        ]),
                        _: 1
                      }),
                      _createVNode(TaiKhoanSelectionV2, {
                        class: "w-100",
                        "ma-tai-khoan-prop": _unref(tkData).maTaiKhoan,
                        "ma-chi-tiet-prop": _unref(tkData).maChiTiet ? _unref(tkData).maChiTiet : undefined,
                        "ten-tai-khoan-prop": _unref(tkData).tenTaiKhoan,
                        onOnClear: _unref(clearTaiKhoanData),
                        onOnSelect: _unref(onSelectTaiKhoan)
                      }, null, 8, ["ma-tai-khoan-prop", "ma-chi-tiet-prop", "ten-tai-khoan-prop", "onOnClear", "onOnSelect"])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_6, [
              (_unref(isCreating))
                ? (_openBlock(), _createBlock(ButtonCustom, {
                    key: 0,
                    classes: `rounded-none m-0`,
                    "button-type": _unref(ButtonsType).ADD,
                    "color-type": _unref(ButtonTypeColors).SUCCESS,
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (onSubmit(false)))
                  }, {
                    "button-label": _withCtx(() => [
                      _createTextVNode("Lưu và tiếp tục")
                    ]),
                    _: 1
                  }, 8, ["button-type", "color-type"]))
                : _createCommentVNode("", true),
              _createVNode(ButtonCustom, {
                classes: `rounded-none m-0`,
                "button-type": _unref(ButtonsType).SAVE,
                "color-type": _unref(ButtonTypeColors).PRIMARY,
                onClick: _cache[7] || (_cache[7] = ($event: any) => (onSubmit(true)))
              }, {
                "button-label": _withCtx(() => [
                  _createTextVNode("Lưu")
                ]),
                _: 1
              }, 8, ["button-type", "color-type"]),
              _createVNode(ButtonCustom, {
                classes: `rounded-none m-0`,
                "button-type": _unref(ButtonsType).REFRESH,
                "color-type": _unref(ButtonTypeColors).WARNING,
                onClick: _cache[8] || (_cache[8] = ($event: any) => (clearForm()))
              }, {
                "button-label": _withCtx(() => [
                  _createTextVNode("Nhập lại")
                ]),
                _: 1
              }, 8, ["button-type", "color-type"])
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(CapSuaChuaTable, {
            "cur-page": _unref(currentPage),
            items: capSuaChuaItems.value,
            "per-page": _unref(perPage),
            "selected-id": _unref(isCreating) ? 0 : _unref(idCapSuaChua)
          }, null, 8, ["cur-page", "items", "per-page", "selected-id"]),
          (_unref(totalItems) > 0)
            ? (_openBlock(), _createBlock(Pagination, {
                key: 0,
                page: _unref(currentPage),
                "page-size": _unref(perPage),
                total: _unref(totalItems),
                onChangePage: onPageChange,
                onChangePageSize: onPageSizeChange
              }, null, 8, ["page", "page-size", "total"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})